<template>
  <div class="product-selector__search">
    <v-collapse-wrapper v-on:beforeToggle="toggleCollapsed">

      <h3>{{question.phrase}}</h3>
      <tooltip
        :question="question"
        v-if="question.showTooltip()"
      ></tooltip>

      <div v-collapse-toggle ref="collapseToggle">
        <svg role="presentation">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg--arrow"></use>
        </svg>
      </div>
      <div v-collapse-content>

        <span class="product-selector__search--wrap">
          <input
            v-model="answer"
            :placeholder="this.prompt"
            @keyup="notifyOfChange"
          >
          <svg role="presentation">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg--search"></use>
          </svg>
        </span>

      </div>

    </v-collapse-wrapper>
  </div>
</template>

<script>
  import Tooltip from '../tooltip.vue';
  import VueCollapse from 'vue2-collapse';

  export default {
    components: {
      Tooltip,
      VueCollapse
    },
    props: [
      'question',
      'initialAnswer',
      'prompt'
    ],
    data: function() {
      return {
        answer: this.initialAnswer,
        collapsed: false
      }
    },
    methods: {
      notifyOfChange() {
        this.$emit('notify-answers-changed', this.question.id, this.answer);
      },
      toggleCollapsed: function() {
        this.collapsed = !this.collapsed;
        this.$refs.collapseToggle.classList.toggle('collapsed');
      },
    },
    watch: {
      initialAnswer: function() {
        // this watch method is required so reset can change the parent's data - and this value will be re-assigned
        this.answer = this.initialAnswer;
      }
    },
  }
</script>
